module.exports = __webpack_public_path__ + "img/83_34.2ae6b4c3.png";